import { FC, useEffect, useState } from "react";
import "./loader.scss";
import { DotLoader, UnifyListIconLoader } from "@components/icons";
import { Skeleton } from "@components/skeleton";
import {
  Panel,
  PanelActionArea,
  PanelBody,
  PanelFooter,
  PanelHeader,
  PanelTitleArea,
} from "@components/panel";

export const enum LoaderType {
  DotLoader = "DotLoader",
  Spinner = "Spinner",
  Default = "Default",
  Deck = "Deck",
}
interface LoaderProps {
  variant?: "full-screen" | "inline" | "full-screen-static";
  type?: LoaderType;
  className?: string;
  size?: string;
  delay?: number;
}

export const DeckShim: FC<{ style?: React.CSSProperties; panelHeight?: string }> = ({
  style,
  panelHeight,
}) => {
  return (
    <div className={`manage-loader-item ${panelHeight}`} style={style}>
      <Panel className={`${panelHeight}`}>
        <PanelHeader variant="white">
          <PanelTitleArea>
            <Skeleton
              style={{ height: "20px", borderRadius: "4px", width: "100px", margin: "4px 0" }}
            />
          </PanelTitleArea>
          <PanelActionArea>
            <Skeleton
              style={{ height: "20px", borderRadius: "4px", width: "20px", margin: "4px 0" }}
            />
          </PanelActionArea>
        </PanelHeader>
        <PanelBody>
          <Skeleton
            style={{
              height: "12px",
              borderRadius: "4px",
              width: "200px",
              margin: "12px 0 0",
            }}
          />
          <Skeleton
            style={{
              height: "12px",
              borderRadius: "4px",
              width: "150px",
              margin: "12px 0 0",
            }}
          />
          <Skeleton
            style={{
              height: "12px",
              borderRadius: "4px",
              width: "120px",
              margin: "12px 0 0",
            }}
          />
          <Skeleton
            style={{
              height: "12px",
              borderRadius: "4px",
              width: "180px",
              margin: "12px 0 0",
            }}
          />
          <Skeleton
            style={{
              height: "12px",
              borderRadius: "4px",
              width: "150px",
              margin: "12px 0 0",
            }}
          />
        </PanelBody>
        <PanelFooter placement="right">
          <Skeleton
            style={{ height: "36px", borderRadius: "4px", width: "100px", margin: "4px 0" }}
          />
        </PanelFooter>
      </Panel>
    </div>
  );
};

export const Loader: FC<LoaderProps> = ({
  variant = "full-screen",
  className = "",
  size,
  delay = 0,
  type = LoaderType.Default,
}) => {
  const [visible, setVisible] = useState(delay === 0);

  useEffect(() => {
    if (delay === 0) return;
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (!visible) return null;

  switch (type) {
    case LoaderType.Deck:
      return (
        <div className="manage-loader">
          {[...Array(10)].map((_, index) => (
            <DeckShim key={index} />
          ))}
        </div>
      );
    case LoaderType.Spinner:
      return <div className={`spinner-loader ${className}`} />;

    case LoaderType.DotLoader:
      return (
        <div className={`loader-container ${variant} ${className}`}>
          <DotLoader color="#333" size={size} />
        </div>
      );
    case LoaderType.Default:
    default:
      return (
        <div className={`loader-container ${variant} ${className}`}>
          <UnifyListIconLoader />
        </div>
      );
  }
};
